import { useState } from "react";

import CircularProgress from "@material-ui/core/CircularProgress";
import { ArrowBack, Delete, Business } from "@material-ui/icons";
import SaveIcon from "@material-ui/icons/Save";
import StorageIcon from "@mui/icons-material/Storage";
import Checkbox from "@material-ui/core/Checkbox";
import axios from "axios";
import { FormikProvider, useFormik } from "formik";
import "react-tabs/style/react-tabs.css";
import styled, { keyframes } from "styled-components";
import { v4 as uuidv4 } from "uuid";
import * as yup from "yup";
import fetchClient from "../../api/fetchClient";
import Tabs from "../../components/aplicacao/Tabs";
import LogsMetadataModal from "../../components/concur/LogsMetadataModal";
import message from "../../helper/message";

const metadataSeidorPath =
	process.env.REACT_APP_METADATA_SEIDOR_PATH || process.env.REACT_APP_METADATA_PATH;
const buildSeidorMetadataUrl = (suffix = "") =>
	metadataSeidorPath ? `${metadataSeidorPath}/metadata${suffix}` : `/metadata${suffix}`;

const validationSchema = yup.object({
	cnpj: yup
		.string()
		.required("CNPJ é obrigatório")
		.matches(/^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/, "CNPJ formato inválido"),
	name: yup.string("Informe o nome da empresa").required("Nome é obrigatório"),
	description: yup
		.string("Informe a descrição da empresa")
		.required("Descrição é obrigatório"),
	login: yup.string("Informe o login do sap").required("Login é obrigatório"),
	password: yup
		.string("Informe a senha do sap")
		.required("Password é obrigatório"),
	database: yup
		.string("Informe o banco de dados")
		.required("Banco de dados é obrigatório"),
	url: yup
		.string("Informe a url da service layer")
		.required("Url da service layer é obrigatório"),
	compra: yup.array(
		yup.object({
			grupoEmpresa: yup
				.string("Informe o grupo da empresa")
				.required("Grupoda emrpesa é obrigatório"),
		})
	),
	hana: yup.object({
		hanaHost: yup.string("Informe o host do hana"),
		hanaDatabase: yup.string("Informe o database do hana"),
		hanaUser: yup.string("Informe o usuário do hana"),
		hanaPassword: yup.string("Informe a senha do hana"),
	}),
	viceri: yup.array(
		yup.object({
			branchId: yup
				.string("Informe o id da filial")
				.required("Filial Id é obrigatório"),
			seqNF: yup
				.string("Informe a sequência NF")
				.required("Sequência NF é obrigatório"),
			usageNF: yup
				.string("Informe o utilização NF")
				.required("Utilização NF é obrigatório"),
			seqNFRet: yup
				.string("Informe a sequência Devolução")
				.required("Sequência devolução é obrigatório"),
			usageNFRet: yup
				.string("Informe o utilização da devolução")
				.required("Utilização Devolução é obrigatório"),
			usageAdto: yup
				.string("Informe o utilização do adiantamento")
				.required("Utilização Adiantamento é obrigatório"),
			itemAdto: yup
				.string("Informe o item do adiantamento")
				.required("Utilização Adiantamento é obrigatório"),
		})
	),
});

const initViceri = {
	branchId: 0,
	seqNF: 0,
	usageNF: 0,
	seqNFRet: 0,
	usageNFRet: 0,
	usageAdto: 0,
	itemAdto: "",
};

const initCompra = {
	grupoEmpresa: "",
	portaDB: "",
	tipoBanco: 0,
	smtpHost: "",
	smtpPort: "",
	smtpLogin: "",
	smtpPassWord: "",
	mailAddress: "",
	enableSsl: false,
	urlPortal: "",
	pais: "",
};

const initAplicacao = {
	id: uuidv4(),
	cnpj: "",
	name: "",
	description: "",
	login: "",
	password: "",
	database: "",
	url: "",
	ativo: true,
	logo: "",
	metadata: false,
	dashboard: false,
	compra: [],
	viceri: [],
};

const initValues = {
	initViceri,
	initCompra,
};

function AplicacaoPage(props) {
	const { data, isViewing } = props;

	console.log(props);

	const [empresa, setEmpresa] = useState(data);
	const [error, setError] = useState(false);

	const [connected, setConnected] = useState(data.connected);
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingHana, setIsLoadingHana] = useState(false);

	const [isLoadingToken, setIsLoadingToken] = useState(false);

	const [metadataCreationId, setMetadataCreationId] = useState(null);

	const [loadingMetadataCreation, setLoadingMetadataCreation] = useState(false);

	const onRetrieveLogs = async () => {
		try {
			const { data } = await axios.get(
				buildSeidorMetadataUrl(`/${metadataCreationId}?type=seidor`)
			);
			return data;
		} catch (error) {
			message.error(error.message);
		}
	};

	const onInitializeMetadataCreation = async (id) => {
		try {
			setLoadingMetadataCreation(true);
			const { data } = await axios.post(
				buildSeidorMetadataUrl(),
				{
					company: id,
					type: "seidor",
				}
			);
			setMetadataCreationId(data.uuid);
		} catch (error) {
			message.error(error.message);
		} finally {
			setLoadingMetadataCreation(false);
		}
	};

	const onSave = async (empresa) => {
		try {
			await fetchClient.post("seidor/aplicacao/createAplicacao", empresa);
			isViewing(false);
			message.sucess("Salvo com sucesso!");
		} catch (error) {
			message.error(error.response.data.message);
		}
	};

	const onDelete = async (id) => {
		const confirmDelete = window.confirm(
			"Tem certeza que deseja deletar esta aplicação? Esta ação não pode ser desfeita."
		);

		if (!confirmDelete) return;

		try {
			await fetchClient.delete(`/seidor/aplicacao/deleteAplicacao/${id}`);
			isViewing(false);
			message.sucess("Registro deletado com sucesso");
		} catch (error) {
			message.error(error.response.data.message);
		}
	};

	const onTestConnect = async () => {
		try {
			if (formik.values.url.indexOf("Login") > 0)
				return message.error(
					"A url da service layer está inválida, exemplo de formato válido https://servicelayer.sample:00000/b1s/v1"
				);
			setIsLoading(true);
			const empresa = {
				login: formik.values.login,
				database: formik.values.database,
				password: formik.values.password,
				url: formik.values.url,
			};
			await fetchClient.post("testConnectionSap", empresa);
			message.sucess("Connectado com sucesso");
			setFieldValue("connected", true);
			setConnected(true);
			setEmpresa((v) => {
				return { ...v, connected: true };
			});
			setIsLoading(false);
		} catch (error) {
			setFieldValue("connected", false);
			setIsLoading(false);
			setEmpresa((v) => {
				return { ...v, connected: false };
			});
			setConnected(false);
			console.log(error);
			message.error(error.response.data.message);
		}
	};

	const onTestConnectHana = async () => {
		try {
			setIsLoadingHana(true);
			const empresa = {
				hPassword: formik.values.hana.hanaPassword,
				urlHanaSql: formik.values.hana.hanaHost,
				hUserName: formik.values.hana.hanaUser,
			};
			await fetchClient.post("testConnHanaByComp", empresa);
			message.sucess("Connectado com sucesso");
			setIsLoadingHana(false);
		} catch (error) {
			setIsLoadingHana(false);
			console.log(error);
			message.error(error.response.data.message);
		}
	};

	const defaultValues = {
		id: empresa.id,
		cnpj: empresa.cnpj || "",
		name: empresa.name || "",
		description: empresa.description || "",
		login: empresa.login || "",
		password: empresa.password || "",
		connected,
		database: empresa.database || "",
		url: empresa.url || "",
		ativo: empresa.ativo || false,
		viceri: empresa.viceri || "",
		compra: empresa.compra || "",
		logo: empresa.logo || "",
		metadata: empresa.metadata || "",
		dashboard: empresa.dashboard || false,
		type: empresa.type || "todos", // 🔥 Novo campo
		hana: {
			hanaDatabase: empresa.hana?.hanaDatabase || "",
			hanaHost: empresa.hana?.hanaHost || "",
			hanaUser: empresa.hana?.hanaUser || "",
			hanaPassword: empresa.hana?.hanaPassword || "",
		},
	};

	const formik = useFormik({
		initialValues: defaultValues,
		validationSchema: validationSchema,
		enableReinitialize: true,
		onSubmit: async (values, actions) => {
			await onSave(values, actions);
		},
	});

	const {
		touched,
		values,
		errors,
		handleChange,
		handleSubmit,
		isSubmitting,
		setFieldValue,
	} = formik;

	if (error) return null;
	return (
		<FormikProvider value={formik}>
			<Container>
				{metadataCreationId && (
					<LogsMetadataModal
						show={(bool) => bool === false && setMetadataCreationId(null)}
						onRetrieveLogs={onRetrieveLogs}
					/>
				)}
				<PageContent>
					<ModernHeader>
						<HeaderLeft>
							<BackButton onClick={() => isViewing(false)}>
								<ArrowBack />
							</BackButton>
							<HeaderContent>
								<PageTitle>
									<Business style={{ marginRight: '12px', fontSize: '32px' }} />
									{empresa.new ? "Nova Aplicação" : "Editar Aplicação"}
								</PageTitle>
								<PageSubtitle>
									{empresa.new ? 'Cadastre uma nova aplicação no sistema' : values.name || 'Gerencie as informações da aplicação'}
								</PageSubtitle>
							</HeaderContent>
						</HeaderLeft>
					</ModernHeader>

					<ActionsCard>
						<ActionsGrid>
							<ActionButton
								variant="danger"
								disabled={empresa.new}
								onClick={async () => await onDelete(empresa.id)}
							>
								<Delete style={{ marginRight: '8px', fontSize: '20px' }} />
								Excluir
							</ActionButton>

							<ActionButton
								variant="primary"
								onClick={handleSubmit}
								disabled={isSubmitting}
							>
								{isSubmitting ? (
									<CircularProgress size={20} style={{ color: 'white' }} />
								) : (
									<>
										<SaveIcon style={{ marginRight: '8px', fontSize: '20px' }} />
										Salvar
									</>
								)}
							</ActionButton>

							<ActionButton
								variant="primary"
								onClick={async () => await onInitializeMetadataCreation(empresa.id)}
							>
								{loadingMetadataCreation ? (
									<CircularProgress size={20} style={{ color: 'white' }} />
								) : (
									<>
										<StorageIcon style={{ marginRight: '8px', fontSize: '20px' }} />
										Criar Metadata
									</>
								)}
							</ActionButton>
						</ActionsGrid>
					</ActionsCard>

					<FormCard>
						<Form autoComplete="off">
							<TypeSection>
								<SectionLabel>Tipo de Aplicação</SectionLabel>
								<RadioGroup>
									<RadioOption>
										<Checkbox
											type="radio"
											name="type"
											value="s3"
											checked={values.type === "s3"}
											onChange={handleChange}
											color="primary"
										/>
										<RadioLabel>S3</RadioLabel>
									</RadioOption>
									<RadioOption>
										<Checkbox
											type="radio"
											name="type"
											value="dashboard"
											checked={values.type === "dashboard"}
											onChange={handleChange}
											color="primary"
										/>
										<RadioLabel>Dashboard</RadioLabel>
									</RadioOption>
									<RadioOption>
										<Checkbox
											type="radio"
											name="type"
											value="todos"
											checked={values.type === "todos"}
											onChange={handleChange}
											color="primary"
										/>
										<RadioLabel>Todos</RadioLabel>
									</RadioOption>
								</RadioGroup>
								{touched.type && errors.type && (
									<ErrorText>{errors.type}</ErrorText>
								)}
							</TypeSection>

							<Tabs
								values={values}
								touched={touched}
								errors={errors}
								handleChange={handleChange}
								initValues={initValues}
								setFieldValue={setFieldValue}
								formik={formik}
								onTestConnect={onTestConnect}
								onTestConnectHana={onTestConnectHana}
								connected={connected}
								isLoading={isLoading}
								isLoadingHana={isLoadingHana}
							/>
						</Form>
					</FormCard>
				</PageContent>
			</Container>
		</FormikProvider>
	);
}

export default AplicacaoPage;

// Animações
const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const Container = styled.div`
	width: 100%;
	min-height: calc(100vh - 65px);
	background-color: #f3f4f6;
	font-family: 'Mulish', sans-serif;
	box-sizing: border-box;
	overflow-x: hidden;
`;

const PageContent = styled.div`
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
	box-sizing: border-box;
	padding: 3rem 2rem;

	@media (max-width: 768px) {
		padding: 2rem 1rem;
	}
`;

const ModernHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	animation: ${fadeIn} 0.6s ease;
	margin-bottom: 2.5rem;

	@media (max-width: 768px) {
		flex-direction: column;
		align-items: flex-start;
		gap: 20px;
	}
`;

const HeaderLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	flex: 1;
`;

const HeaderContent = styled.div`
	flex: 1;
`;

const PageTitle = styled.h1`
	font-size: 28px;
	font-weight: 700;
	color: #2c3e50;
	margin: 0 0 6px 0;
	display: flex;
	align-items: center;
	font-family: 'Mulish', sans-serif;

	@media (max-width: 768px) {
		font-size: 22px;
	}
`;

const PageSubtitle = styled.p`
	font-size: 14px;
	color: #7f8c8d;
	margin: 0;
	font-family: 'Mulish', sans-serif;
`;

const BackButton = styled.button`
	background: rgba(102, 126, 234, 0.1);
	border: none;
	border-radius: 12px;
	width: 42px;
	height: 42px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	color: #667eea;
	transition: all 0.3s ease;
	flex-shrink: 0;

	&:hover {
		background: rgba(102, 126, 234, 0.2);
		transform: translateX(-4px);
	}

	&:active {
		transform: translateX(0);
	}
`;

const ActionsCard = styled.div`
	background: white;
	border: 1px solid #e8e8e8;
	border-radius: 16px;
	padding: 20px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	animation: ${fadeIn} 0.5s ease 0.1s both;
	transition: all 0.3s ease;
	width: 100%;
	box-sizing: border-box;
`;

const ActionsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
	gap: 12px;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

const ActionButton = styled.button`
	background: ${props => {
		if (props.variant === 'danger') return 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)';
		if (props.variant === 'success') return 'linear-gradient(135deg, #27ae60 0%, #229954 100%)';
		if (props.variant === 'warning') return 'linear-gradient(135deg, #f39c12 0%, #e67e22 100%)';
		return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
	}};
	color: white;
	border: none;
	border-radius: 12px;
	padding: 12px 20px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.3s ease;
	font-family: 'Mulish', sans-serif;
	box-shadow: 0 2px 8px ${props => {
		if (props.variant === 'danger') return 'rgba(231, 76, 60, 0.3)';
		if (props.variant === 'success') return 'rgba(39, 174, 96, 0.3)';
		if (props.variant === 'warning') return 'rgba(243, 156, 18, 0.3)';
		return 'rgba(102, 126, 234, 0.3)';
	}};

	&:hover:not(:disabled) {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px ${props => {
			if (props.variant === 'danger') return 'rgba(231, 76, 60, 0.4)';
			if (props.variant === 'success') return 'rgba(39, 174, 96, 0.4)';
			if (props.variant === 'warning') return 'rgba(243, 156, 18, 0.4)';
			return 'rgba(102, 126, 234, 0.4)';
		}};
	}

	&:active:not(:disabled) {
		transform: translateY(0);
	}

	&:disabled {
		background: #bdbdbd;
		cursor: not-allowed;
		box-shadow: none;
		opacity: 0.6;
	}
`;

const FormCard = styled.div`
	background: white;
	border: 1px solid #e8e8e8;
	border-radius: 16px;
	padding: 28px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	animation: ${fadeIn} 0.5s ease 0.2s both;
	transition: all 0.3s ease;
	width: 100%;
	box-sizing: border-box;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		border-color: #d0d0d0;
	}
`;

const Form = styled.form`
	width: 100%;
`;

const TypeSection = styled.div`
	padding-bottom: 24px;
	border-bottom: 2px solid #f0f0f0;
`;

const SectionLabel = styled.label`
	font-size: 16px;
	font-weight: 600;
	color: #2c3e50;
	margin-bottom: 16px;
	display: block;
`;

const RadioGroup = styled.div`
	display: flex;
	gap: 24px;
	margin-top: 12px;
`;

const RadioOption = styled.label`
	display: flex;
	align-items: center;
	cursor: pointer;
	user-select: none;
`;

const RadioLabel = styled.span`
	font-size: 14px;
	color: #2c3e50;
	font-weight: 500;
`;

const ErrorText = styled.div`
	color: #e74c3c;
	font-size: 12px;
	margin-top: 8px;
	font-weight: 500;
`;
